import { Common } from './common';
import { EncounterProblem, CreateValues } from './models/encounterProblem';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findOneById(encounterProblemId: string): Promise<EncounterProblem> {
    const url = this.common.constructPath(
      `/encounterProblem/${encounterProblemId}`,
    );
    const { encounterProblem } = await this.common.getJSON(url);
    return encounterProblem;
  }

  async create(encounterProblem: CreateValues): Promise<EncounterProblem> {
    const url = this.common.constructPath('/encounterProblem/create');
    return this.common.postJSON(url, encounterProblem);
  }
}
